import { Component, effect, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule, LoadingController } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../providers/auth/authentification.service';
import { catchError, EMPTY } from 'rxjs';

@Component({
  selector: 'app-user',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule, TranslateModule],
})
export class LoginPage {
  private authService = inject(AuthService);
  private translate: TranslateService = inject(TranslateService);
  private loadingController: LoadingController = inject(LoadingController);

  fullAppVersion = signal(environment.fullAppVersion);
  loginPending = signal<'NO_LOGIN' | 'LOGIN_STARTED' | 'LOGIN_FINISHED'>('NO_LOGIN');

  constructor() {
    effect(async () => {
      if (this.loginPending() === 'LOGIN_STARTED') {
        await this.presentLoading();
      } else if (this.loginPending() === 'LOGIN_FINISHED') {
        await this.dismissLoading();
      }
    });
  }

  authenticateUser() {
    this.loginPending.set('LOGIN_STARTED');
    this.authService
      .forceAuthentification('normal')
      .pipe(
        catchError((_) => {
          return EMPTY;
        })
      )
      .subscribe(() => {
        this.loginPending.set('LOGIN_FINISHED');
      });
  }

  private async presentLoading() {
    const loading = await this.loadingController.create({
      message: this.translate.instant('LOGIN.CONNECTING'),
      translucent: true,
    });
    return await loading.present();
  }

  private async dismissLoading() {
    await this.loadingController.dismiss();
  }
}
